import { Row } from '@guestyci/foundation/esm/Layout';
import TextField from '@guestyci/foundation/TextField';
import createStyles from '@guestyci/foundation/createStyles/createStyles';
import useMediaQuery from '@guestyci/foundation/useMediaQuery/useMediaQuery';
import { useMediaQuery as useMQ } from 'react-responsive';
import _extends from '@babel/runtime/helpers/esm/extends';
import AppStyle from '../Styles';

const useStyles = createStyles(() => _extends(AppStyle, {}));

const mediaQuery = {
  maxWidth: 'md',
};

const NotFound = () => {
  const classes = useStyles();
  const isMobile = useMediaQuery(mediaQuery);
  const isSmallHeight = useMQ({ query: '(max-height: 800px)' }) || isMobile;
  return (
    <Row
      fullWidth
      align="center"
      justify="center"
      id="not-found-page-container"
      className="not-found-page-container"
    >
      <TextField
        className={[classes.pageHeading, isSmallHeight ? classes.pageHeadingSmallHeight : '']}
        align={isMobile ? 'center' : 'left'}
      >
        Page Not Found
      </TextField>
    </Row>
  );
};

export default NotFound;
